<ng-template #template1>
  <div class="modal-header border-0 pb-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="filterVal.startIndex = 1;modalMeeting.hide();loadGeneralInfo();">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div>
  <app-view-attendence pagetype="ATTENDANCE" [viewType]="viewType" [mid]="mid" [inpUserList]="UserList"></app-view-attendence>
</ng-template>

  <ng-template #template>
    <div class="modal-header pb-0 border-0">
      <div class="custom-tab d-block w-100">
        <h4 class="modal-title text-left px-2 f-bold-dubai pb-3">Create new Attendance </h4>
        <!--<small class="px-2"><a class="text-secondary" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();"><i class="ti ti-arrow-left"></i> Back to Attendance</a></small>-->
        <button type="button" class="close close-abs text-right" id="addclose" name="addclose" #addclose aria-label="Close" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();">
          <span aria-hidden="true"><i class="la la-close"></i></span>
        </button>
      </div>
    </div>
    <app-add-attendence pagetype="ATTENDANCE" [attendanceEditUno]="attendanceEditUno" [inpUserList]="UserList" ></app-add-attendence>

  </ng-template>
<div class="bg-light border-bottom ">
  <div class="container-fluid clearfix">
    <div class="float-md-right float-sm-right float-xs-right top-nav-btn res-fixed-x-space">
      <div class="d-inline-block mx-1 py-2">
        <button type="button" (click)="exportXL()" class="h-38 px-3 btn text-left btn-block d-sm-block btn-outline-light-gray  font-weight-bold position-relative"><i class="ti ti-export pr-1 fs-14"></i> Export</button>
      </div>
      <div class="d-inline-block mx-1 py-2 drop-minus-top">
        <select id="inputState" (change)="onChangeSortBy($event.target.value)"
                class="pl-3 pr-4 btn-block d-sm-block form-control font-weight-bold grey-border btn-select">
          <option selected value="date">Sort by Created</option>
          <option value="meetingdate">Sort by Meeting Date</option>
          <option value="subject">Sort by Subject</option>
          <option value="meetingName">Sort by Meeting Type</option>
          <option value="locationName">Sort by Location</option>
          <option value="approvalStatus">Sort by Status</option>
        </select>
      </div>
      <div class="d-inline-block mx-1 py-2 hide-dropdown filter-overflow" #inputBox (click)="$event.stopPropagation()" ngbDropdown>
        <!--<button type="button" class="px-3 btn text-left btn-block d-sm-block btn-outline-light-gray  font-weight-bold position-relative" ><i class="la la-filter pr-1 fs-14"></i> Filter </button>
        <button type="button" class="px-3 btn btn-sm text-left btn-block d-sm-block btn-outline-light-gray font-weight-bold" ngbDropdownToggle>
    <i class="la la-filter"></i> Filter ({{filterCount}})
  </button>
  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="keep-open" id="drophide">
    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues();"><input class="form-check-input minus-5" type="checkbox" name="created" [(ngModel)]="created" value="" id="Created"><label class="form-check-label px-3" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues();" for="Created">Created by Me</label>  </a></li>
    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forImp=!filterVal.forImp;loadFilterValues();"><input class="form-check-input minus-5" type="checkbox" name="important" [(ngModel)]="important" value="" id="Important"><label class="form-check-label px-3" (click)="filterVal.forImp=!filterVal.forImp;loadFilterValues();" for="Important">Important</label>  </a></li>
    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues();"><input class="form-check-input minus-5" type="checkbox" name="publish" [(ngModel)]="publish" value="" id="Publish"><label class="form-check-label px-3" (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues();" for="Publish">For Publish</label>  </a></li>
    <li><a ngbDropdownItem (click)="clearAllFilter()"><i class="la la-close minus-5"></i> Clear All</a></li>
  </ul>-->
      </div>
    </div>
  </div>
</div>
<div class="container-fluid py-3 px-3 left-menu-space" id="divMainContainer">
  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-2">Digital Attendance</h4>
    <div class="page-title-right pb-2">
      <a class="btn btn-success text-white py-2 px-3" (click)="openModal(template,0)"><i class="fa fa-plus pr-1"></i> NEW DIGITAL ATTENDANCE</a>
    </div>
  </div>
  <div class="py-2">
    <ul class="list-inline filter-btn">
      <li class="list-inline-item px-0 mx-0"><b>Smart Filters:</b></li>
      <li class="list-inline-item" ngClass="{{filterVal.forOwner || actionType =='createdby'?'active':''}}" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues();">Created by Me</li>
      <!--<li class="list-inline-item" ngClass="{{filterVal.forReview || actionType =='approval'?'active':''}}" (click)="filterVal.forReview=!filterVal.forReview;loadFilterValues()">For Review</li>
  <li class="list-inline-item" ngClass="{{filterVal.forApprove || actionType =='approval'?'active':''}}" (click)="filterVal.forApprove=!filterVal.forApprove;loadFilterValues()">For Approval</li>-->
      <li class="list-inline-item" ngClass="{{filterVal.forImp?'active':''}}" (click)="filterVal.forImp=!filterVal.forImp;loadFilterValues();">Important</li>
      <li class="list-inline-item" ngClass="{{filterVal.forPublish?'active':''}}" (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues();">For Publish</li>
      <li class="list-inline-item">&nbsp;</li>
      <!--<li class="list-inline-item" ngClass="{{filterVal.forDelay?'active':''}}" (click)="filterVal.forDelay=!filterVal.forDelay;loadFilterValues()">With Delayed Actions</li>-->
      <!--<li class="list-inline-item nav-item" ngbDropdown>
        <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle>+ More Filters</a>
        <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <li><a ngbDropdownItem (click)="filterVal.forAction=!filterVal.forAction;loadFilterValues()">Action Assinged To Me</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues()">For Publish</a></li>

        </ul>
      </li>-->
    </ul>
  </div>
  <div class="bg-white p-4 text-center text-muted rounded mb-3" *ngIf="isLoader">
    <div class="loader-bg"></div>
  </div>
  <h5 class="text-secondary" *ngIf="getTodayMeeting().length>0"><b>Today</b></h5>
  <div class="bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="meetingList.length ===0 && !isLoader ">
    <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
    <h5 class="pb-4 pt-2 text-center text-secondary py-sm-5 my-sm-5">No Data Available</h5>
  </div>
  <div class="card rounded pt-2 h-100" *ngFor="let item of getTodayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item)"></div>
      <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4" (click)="openModalnewMeeting(template1,item)">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item" *ngIf="item.impCheck == true">
            <a title="Important" data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a title="Files" data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black mr-1 minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li *ngIf="item.published!=1"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <!--<li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'edit')"><i class="fa fa-edit"></i> Edit</a></li>-->
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="fa fa-eye"></i> View</a></li>

              <li *ngIf="(item.workFlowCondition1 || item.published==5) && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <!--<li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
          <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>-->
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>

      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'MMM'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>

  <h5 class="text-secondary" *ngIf="getYesterdayMeeting().length>0"><b>Yesterday</b></h5>

  <div class="card rounded pt-2 h-100" *ngFor="let item of getYesterdayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item)"></div>
      <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li title="Important" class="list-inline-item" *ngIf="item.impCheck == true">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a title="Files" data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black mr-1 minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li *ngIf="item.published!=1"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="fa fa-eye"></i> View</a></li>
              <!--<li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Approve</a></li>
          <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Review</a></li>-->
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <!--<li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
          <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>-->
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">Sun</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <h5 class="text-secondary" *ngIf="getOlderMeeting().length>0"><b>Older</b></h5>


  <div class="card rounded pt-2 h-100" *ngFor="let item of getOlderMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item)"></div>
      <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item" *ngIf="item.impCheck == true">
            <a title="Important" data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a title="Files" data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black mr-1 minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li *ngIf="item.published!=1"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="fa fa-eye"></i> View</a></li>
              <!--<li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Approve</a></li>
          <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Review</a></li>-->
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <!--<li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
          <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>-->
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">Sun</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <div class="text-center" *ngIf="!disableMore"><a class="btn btn-sm btn-outline-secondary" (click)="loadGeneralInfo()">Load More..</a></div>
</div>

<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">File Attachment</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 px-2 pb-70">
        <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of fileList">
          <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
          <div class="attachement-card rounded p-2 mt-2">
            <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
            <div class="card-controls float-right text-secondary pt-1">
              <ul class="list-inline list-badge hide-arrow-drop">

                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary" (click)="modalPub.hide()">Close</button>

  </div>
</ng-template>
